export default "__VITE_ASSET__DXwOPtnQ__"